<template>
  <el-drawer
    ref="drawer"
    :size="size"
    :destroy-on-close="true"
    @close="closeDrawer"
    :before-close="beforeClose"
    :visible.sync="viewDrawer"
    :title="title"
    :wrapperClosable="wrapperClosable"
    class="app-drawer"
  >
    <slot></slot>
  </el-drawer>
</template>

<script>
import { isMobile, isDesktop } from "mobile-device-detect";
export default {
  data: () => ({
    viewDrawer: false
  }),
  props: {
    isBusy: Boolean,
    title: String,
    wrapperClosable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMobile() {
      return isMobile;
    },
    isDesktop() {
      return isDesktop;
    },
    size() {
      return isMobile ? "100%" : "55%";
    }
  },
  methods: {
    open() {
      this.viewDrawer = true;
    },
    close() {
      this.viewDrawer = false;
    },
    closeDrawer() {
      this.$emit("close");
    },
    beforeClose(done) {
      //   this.$emit("beforeClose");
      if (this.isBusy) return false;
      return done();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-drawer__header {
    margin-bottom: 1rem;
  }
}
</style>
